import React, { useState } from 'react';
import { IFileList } from "../type/upload-document-modal.types";
import MetaForm from "./meta-form";
import Checkbox from "antd/lib/checkbox/Checkbox";
import { ChevronUp, FileCheck, Trash } from "lucide-react";


const MetaFileList: React.FC<IFileList> = (props) => {

    const [applyToAll, setApplyToAll] = useState(false);
    const [openForms, setOpenForms] = useState<Record<string, boolean>>({});
    const [openGlobalForm, setOpenGlobalForm] = useState<boolean>(false);

    function toggleForm(uid: string) {
        setOpenForms((prev) => ({
            ...prev,
            [uid]: !prev[uid]
        }));
    }

    const hasMetaFields = props.metaData && props.metaData.length > 0;

    return (
        <>
            {props.uploadedFiles.length === 1 ?
                (
                    <div className="file-meta__item">
                        <div className="file-meta__item--details">
                            <FileCheck className="file-meta__icon"/>

                            <div className="file-meta__details">
                                <span className="file-meta__name">{props.uploadedFiles[0].file.name}</span>
                                <p className="file-meta__size">{props.uploadedFiles[0].file.size}</p>
                            </div>

                            <span className={`file-meta__add-link ${hasMetaFields ? 'show' : 'hide'}`}
                                  onClick={(e) => {
                                      e.preventDefault();
                                      toggleForm(props.uploadedFiles[0].file.uid);
                                  }}
                            >
                                Add meta
                            </span>
                            <Trash
                                className="file-meta__action file-meta__action--delete"
                                onClick={() => props.handleFileDelete(props.uploadedFiles[0].file)}
                            />
                            <ChevronUp
                                className={`arrow-icon ${hasMetaFields ? "show" : 'hide'} ${!openForms[props.uploadedFiles[0].file.uid] ? 'down' : 'up'}`}
                                onClick={(e) => {
                                    e.preventDefault();
                                    toggleForm(props.uploadedFiles[0].file.uid);
                                }}
                            />
                        </div>
                        {props.metaData && openForms[props.uploadedFiles[0].file.uid] && (
                            <MetaForm
                                uid={props.uploadedFiles[0].file.uid}
                                metaData={props.metaData}
                                handleGlobalMetaData={props.handleGlobalMetaData}
                                handleMetaFormSubmit={props.handleMetaFormSubmit}
                            />
                        )}
                    </div>

                ) : props.uploadedFiles.length > 1 ? (
                    <>
                        {props.metaData && props.metaData.length > 0 && (
                            <div className="file-meta__global">
                                <div className={'file-meta__global-details'}>
                                    <Checkbox
                                        checked={applyToAll}
                                        onChange={() => {
                                            setApplyToAll(!applyToAll)
                                            setOpenGlobalForm(!openGlobalForm)
                                        }}
                                    />
                                    <div className="file-meta__global-content">
                                   <span className="file-meta__global-title">
                                       Apply same meta data to all files
                                   </span>
                                        <p className="file-meta__global-description">
                                            Fill once — sync to every uploaded file instantly
                                        </p>
                                    </div>
                                    <button className="file-meta__global-btn"
                                            onClick={() => {
                                                setApplyToAll(!applyToAll)
                                                setOpenGlobalForm(!openGlobalForm)
                                            }}

                                    >Fill Now
                                    </button>
                                </div>
                                {openGlobalForm &&
                                <MetaForm
                                    key={'globalForm'}
                                    metaData={props.metaData}
                                    handleMetaFormSubmit={props.handleMetaFormSubmit}
                                    handleGlobalMetaData={props.handleGlobalMetaData}
                                />}
                            </div>


                        )}

                        <div className="file-meta__list">
                            {props.uploadedFiles.map((obj) => (
                                <div key={obj.file.uid} className="file-meta__item">
                                    <div className="file-meta__item--details">
                                        <span className={"file-meta__icon-wrapper"}>
                                        <FileCheck className="file-meta__icon"/>
                                        </span>

                                        <div className="file-meta__details">
                                            <span className="file-meta__name">{obj.file.name}</span>
                                            <p className="file-meta__size">{obj.file.size}</p>
                                        </div>

                                        <span className={`file-meta__add-link ${hasMetaFields ? 'show' : 'hide'}`}
                                              onClick={(e) => {
                                                  e.preventDefault();
                                                  toggleForm(obj.file.uid);
                                              }}
                                        >
                                              Add meta
                                        </span>
                                        <Trash
                                            className="file-meta__action file-meta__action--delete"
                                            onClick={() => props.handleFileDelete(obj.file)}
                                        />
                                        <ChevronUp
                                            className={`arrow-icon ${hasMetaFields ? "show" : 'hide'} 
                                            ${!openForms[obj.file.uid] ? 'down' : 'up'}`}
                                            onClick={(e) => {
                                                e.preventDefault();
                                                toggleForm(obj.file.uid);
                                            }}
                                        />
                                    </div>
                                    {props.metaData && openForms[obj.file.uid] && (
                                        <MetaForm
                                            key={obj.file.uid}
                                            uid={obj.file.uid}
                                            metaData={props.metaData}
                                            handleGlobalMetaData={props.handleGlobalMetaData}
                                            handleMetaFormSubmit={props.handleMetaFormSubmit}
                                        />
                                    )}
                                </div>
                            ))}
                        </div>
                    </>
                ) : (
                    <>
                    </>
                )
            }
        </>
    )
}

export default MetaFileList;
